
import { map, retryWhen, flatMap, take, concat, delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { GlobalconfigService } from '../common/globalConfig.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { throwError } from 'rxjs/internal/observable/throwError';
import { Observable, of } from 'rxjs';
import { Utils } from './utils';


@Injectable()

export class AuthenticationService {
    userDetails: any;
    public redirectUrl;
    jwt = new JwtHelperService();

    constructor(private http: HttpClient, private config: GlobalconfigService) { }

    login(dataToSend): Observable<any> {
        console.log("global config 2",this.config)
        let url = this.config.baseApiUrl + 'user/loginAuthenticate';
        return this.http.post(url, dataToSend).pipe(map((res: Response) => res),
        retryWhen(error => {return error})
                ,flatMap((error: any) => {
                    if (error.status === 503) {
                        return of(error.status).pipe(delay(1000))
                    }
                    return throwError(()=>{ error: 'No retry' });
                })
                ,take(5)
                 ,concat(throwError(()=>{ error: 'Sorry, there was an error (after 5 retries)' }))
        );

    }

    loginAttempt(dataToSend) {
        console.log("global config 3",this.config.baseApiUrl)
        let url = this.config.baseApiUrl + 'user/loginAttempt';
        return this.http.post(url, dataToSend);
    };

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userToken');
    };

    isAuthenticated() {
        // var userLoginDetails = localStorage.getItem('userToken');
        // this.getUserDetails(userLoginDetails);
        // return (
        //     this.userDetails &&
        //     userLoginDetails != null &&
        //     !this.jwt.isTokenExpired(userLoginDetails)
        // );
        let token=localStorage.getItem("access_token")
        if (token) {
             var userLoginDetails = localStorage.getItem('userToken');
             this.getUserDetails(userLoginDetails);
            return (userLoginDetails !=null &&
              token != null && 
              !this.isTokenExpired1(token)
            );
          }
          return false;
    }
    isTokenExpired1(token: string): boolean {

        if (!token) return true;
    
      try {
        const decoded = this.jwt.decodeToken(token);
        const currentTime = Math.floor(new Date().getTime() / 1000);
        const eightHoursInSeconds = 8 * 60 * 60;
        
        // Check if the current time exceeds the token's expiry time by 8 hours
        return currentTime > (decoded.exp + eightHoursInSeconds);
      } catch (error) {
        console.error('Error decoding token', error);
        return true;
      }
    
    
      }


    getUserDetails(token) {
        const decodeToken = this.jwt.decodeToken(token);
        this.userDetails = {
            loginId: decodeToken.username,
            password: decodeToken.defaultPassword
        }
    }
}